<template>
    <div>
        
    </div>
</template>
<script>
    import {
        Viewer,
        IonResource,
        CesiumTerrainProvider,
        ScreenSpaceEventType,
        Rectangle,
        Math as cesiumMath,
        ScreenSpaceEventHandler,
        Cartesian3,
        SceneMode
    } from 'cesium';
    import 'cesium/Build/Cesium/Widgets/widgets.css';
import cesiumUtil from '../../utils/cesiumUtils';
export default{
    data(){
        return {
            model:true,
            handler:null,
            V:null
        } 
    },
    computed:{
     
    },
    methods:{
        toggleHandler(value){
           if(value){
             this.unActive2D();
             //this.V.scene.morphTo2D(1);//二维
           }else{
              this.Active2D();
             //this.V.scene.morphTo3D(1);//三维
           }
        },
        Active2D(){
           let that=this;
            let V=this.V;
            this.handler = new ScreenSpaceEventHandler(V.scene.canvas);
            let D3ConfigCamera=this.D3Config.Camera;
             let positionParams={
                lon:D3ConfigCamera.center[0],
                lat:D3ConfigCamera.center[1],
                height:D3ConfigCamera.height,
                heading:D3ConfigCamera.heading,
                pitch:D3ConfigCamera.pitch,
                roll:D3ConfigCamera.roll,
              };
            cesiumUtil.initialCameraPosition(V,positionParams)
            // V.camera.setView({
            //     destination : Rectangle.fromDegrees(InitrRectange[0],InitrRectange[1],InitrRectange[2],InitrRectange[3])
            // });
            // disable the default event handlers
            // 左键旋转球
            V.scene.screenSpaceCameraController.enableRotate = true;
            // 二维模式平移
            V.scene.screenSpaceCameraController.enableTranslate = false;
            //滚轮缩放
            V.scene.screenSpaceCameraController.enableZoom = true;
            //中键拖动球
            V.scene.screenSpaceCameraController.enableTilt = false;
            V.scene.screenSpaceCameraController.enableLook = false;
            function ExentLimit(){
                let maxExtent=that.D3Config.Camera.maxExtent;  
                let rectangleCoor=V.camera.computeViewRectangle();
                let isOver=rad2deg(rectangleCoor.west)<maxExtent[0]
                    ||rad2deg(rectangleCoor.south)<maxExtent[1]
                    ||rad2deg(rectangleCoor.east)>maxExtent[2]
                    ||rad2deg(rectangleCoor.north)>maxExtent[3];
                if(isOver){
                 
                    V.camera.setView({
                        destination : Rectangle.fromDegrees(maxExtent[0],maxExtent[1],maxExtent[2],maxExtent[3])
                    });
                }
            }
            window.V=V;
            this.handler.setInputAction(function(wheelment) {
                //ExentLimit();
            }, ScreenSpaceEventType.WHEEL);
            this.handler.setInputAction(function(wheelment) {
                //ExentLimit();
            }, ScreenSpaceEventType.MOUSE_MOVE);
            function rad2deg(rad){
                return rad*180/Math.PI;
            }
        },
        unActive2D(){
            let self=this;
            this.V.scene.screenSpaceCameraController.enableTranslate = true;
            this.V.scene.screenSpaceCameraController.enableTilt = true;
            this.V.scene.screenSpaceCameraController.enableLook = true;
            if(this.handler){
              this.handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE)
              this.handler.removeInputAction(ScreenSpaceEventType.WHEEL)
            }
            setTimeout(() => {
              self.V.flyTo(this.D3Config.tiles);
            }, 2000)

        }
    }, 
    created(){
        

     
    },
    mounted(){
        setTimeout(()=>{
              this.V= this.D3Config.Viewer;
        },1000)
     
    },
    watch:{
    
    }
}
</script>
<style>
.toggle23D{
    position:absolute;
    right:10px;
    bottom:100px;

}
</style>
